import { type ComponentProps } from "react";

import { type Customer } from "@prisma/client";
import { Link, useRouteLoaderData } from "@remix-run/react";

import { HeartIcon } from "~/icons";
import { cn } from "~/lib/utils";

import { CartLink } from "../CartLink";

export default function ToolBar({ className }: { className?: string }) {
    const { customer, withAuthKit } = useRouteLoaderData<{ withAuthKit: boolean; customer: Customer }>(
        "routes/_store+/_breadcrumbs+/_layout",
    );

    return (
        <div className={cn("flex items-center gap-4 text-xs sm:text-base", className)}>
            {/* <CustomerLinks customer={customer} withAuthKit={withAuthKit} /> */}
            <CartLink />
        </div>
    );
}

export function CustomerLinks({
    className,
    customer,
    withAuthKit,
}: {
    className?: string;
    customer: Customer;
    withAuthKit: boolean;
}) {
    const { to, text } = withAuthKit ? { to: "/auth/logout", text: "Sign out" } : { to: "/authkit", text: "Sign in / Register" };

    return (
        <div className={cn("flex items-center justify-end gap-4", className)}>
            {withAuthKit ? (
                <>
                    <Favorites customer={customer} />
                    <Initials customer={customer} />
                </>
            ) : null}

            <Link to={to} className="hover:underline border-zinc-800/50 line-clamp-1" aria-label={text}>
                {text}
            </Link>
        </div>
    );
}

function Initials({ customer }: { customer: Customer }) {
    return (
        <div className="flex justify-center items-center h-8 sm:h-10 w-8 sm:w-10 text-xs md:text-base rounded-full bg-muted">
            {customer.firstName?.charAt(0) || ""}
            {customer.lastName?.charAt(0) || ""}
        </div>
    );
}

function Favorites({ customer }: { customer: Customer }) {
    return (
        <Link to="/favorites" className="relative" aria-label="Favorites">
            <HeartIcon width="1.3em" height="1.3em" className="hover:text-rose-600" />
            <Dot className={Array(customer?.favorites)?.length ? "opacity-100" : "opacity-0"} />
        </Link>
    );
}

function Dot({ className }: ComponentProps<"div">) {
    return (
        <div
            className={cn(
                "absolute bg-destructive w-2 h-2 sm:w-3 sm:h-3 top-0 right-0 translate-x-2/4 -translate-y-2/4 transition-opacity duration-300 rounded-full",
                className,
            )}
        />
    );
}
